import {dateToUTC, getNextDateFrom} from "./helpers";

export const nowDay = () => dateToUTC(new Date());
export const lastWeekKey = "lastWeek";

export const intervalLimits = {
  YEAR: 12,
  MONTH: { FROM: 28, TO: 31 },
  QUARTER: { FROM: 88, TO: 92 },
  MAX_VALUE_BY_ONE_DAY: 15,
};

export const getStartDate = (): string => getNextDateFrom(nowDay(), { days: 1 }).toISOString();
